import {get,post,url,fetch} from '../http'

class Wisdom{
    // 专栏列表
    @url("/s/open/column/list/")
    @fetch
    getColumnLsit(){}
    //学科列表
    @url("/s/open/subject/list")
    @get
    getSubjectList(){}

    // 课程列表
    @url("/s/open/course/list")
    @get
    getCourseList(){}

    // 课程详情
    @url("/s/open/course/courseInfo/")
    @fetch
    getCourseInfo(){}

    // 课节列表
    @url("/s/open/lesson/list/")
    @fetch
    getLessonList(){}

    // 获取推荐课程
    @url("/s/open/course/openRecommendCourse")
    @get
    getRecommend(){}

    // 获取职称列表
    @url("/s/open/user/title/list")
    @get
    getTitleList(){}

    // 获取专家列表
    @url("/s/open/user/expert/list")
    @get
    getExpertList(){}

    // 获取专项列表
    @url("/s/open/course/category")
    @get
    getCategoryList(){}

    // 获取项目案例 （）
    @url("/news/list") //clazz 4.首师智研项目案例 5.1+x 6.内蒙古
    @get
    getProjectList(){}

    // 项目详情页 获取最新推荐
    @url("/news/recommend") 
    @get
    getProjectRecommend(){}

     // 获取专业列表 (1+x项目)
     @url("/s/open/specialty/list")
     @get
     getSpecialtyList(){} 

     // 获取专业列表 （内蒙古项目）
     @url("/s/open/course/type")
     @get
     getCourseType(){} 

}

export default new Wisdom()